import React from "react";

interface TablePaginationProps {
  currentPage: number;
  totalCount: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rows: number) => void;
  isGrid?: boolean;
}

const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  totalCount,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isGrid = false,
}) => {
  const rowOptions = isGrid ? [8, 16, 32, 56] : [5, 10, 25, 50];
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  const startItem = totalCount === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;

  const endItem = Math.min(currentPage * rowsPerPage, totalCount);

  if (totalCount === 0) return null;

  return (
    <div className="flex items-center justify-end gap-6 px-4 py-3 border-t bg-white">
      {/* Rows Per Page */}
      <div className="flex items-center gap-2">
        <span className="text-sm">Rows per page:</span>

        <select
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          className="border rounded px-4 py-1"
        >
          {rowOptions.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>

      {/* Showing */}
      <div className="text-sm text-gray-700">
        {startItem}-{endItem} of {totalCount}
      </div>

      {/* Pagination Buttons */}
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className="px-2 py-1 border rounded disabled:opacity-40"
        >
          {"<<"}
        </button>

        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-2 py-1 border rounded disabled:opacity-40"
        >
          {"<"}
        </button>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-2 py-1 border rounded disabled:opacity-40"
        >
          {">"}
        </button>

        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="px-2 py-1 border rounded disabled:opacity-40"
        >
          {">>"}
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
